export class ZoneId {
  static readonly TravelAlertBanner = 'TravelAlertBanner';
  static readonly TravelAlertConfirmationBanner =
    'TravelAlertConfirmationBanner';
  static readonly Home = 'Home';
  static readonly Confirmation = 'Confirmation';
}
